import {
    setSliceLyricDesc,
    setSliceTabIndex,
    setSliceLyricContent,
    setSliceIncidentalAudioInfo,
    setSliceAudioInfo,
    setSliceVocalAudioInfo,
    setSliceUploadAudioStatus,
    setSliceVocalUploadAudioStatus,
    setSliceIncidentalAudioStatus,
    setSlicePresetList,
    setSliceReferenceMusicList,
    setSliceReferenceVocalList,
    setSliceInstrumentalList,
    setSliceIsGenerateLyricsLoading,
    setSliceIsMultipleMode,
    setSlicePrompt,
    setSliceHistoryTabIndex,
    setSliceMusicFreeNumCreationAction,
    setSliceIntFreeNumCreationAction,
    setSliceSFXFreeNumCreationAction,
    setSliceSFXPresetList,
    setSliceInsPresetList,
    AI_AUDIO_USE_CREDIT,
} from '../slices/FJSliceAIAudioGenerator';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJConstant from '../../constants/FJConstant.js';
import FJUtil from '../../util/FJUtil.js';
import {
    MAX_POLLING_ERROR_TIME,
    TASK_POLLING_INTERVAL,
    UPLOAD_FILE_TYPE_OF_AUDIO,
} from '../../config/dataConfig/FJGenerateData.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJConfig from '../../config/FJConfig.js';
import FJImageStore from '../../store/FJImageStore.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJActionCommon from './FJActionCommon.js';
import {
    setSliceTaskStatusAction,
    setSliceHistoryListAction,
    setSliceHistoryListLoadStatusAction,
    setSliceSelectListAction,
} from '../slices/FJSliceCommon.js';
import FJActionModal from './FJActionModal.js';
import FJActionRecord from './FJActionRecord.js';
import Download from '../../lib/download.js';
import FJAudioPlayManager from '../../store/FJAudioPlayManager.js';
import FJActionEditPage from './FJActionEditPage.js';

let f_timer = null;
let f_errorTime = 0;
let f_currentWaveId = null;

const _formatError = () => {
    FJMessageStore.addMessage(FJLocalStore._('unsupported-format-please-upload-mp3-wav-files'), 'error');
};

const _time15Error = () => {
    FJMessageStore.addMessage(FJLocalStore._('music-should-be-at-least-15s'), 'error');
};

const _time600Error = () => {
    FJMessageStore.addMessage(FJLocalStore._('music-should-be-within-10-mins'), 'error');
};

const FJActionAIAudioGenerator = {
    resetAction: function () {
        return dispatch => {
            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(false));
            dispatch(FJActionAIAudioGenerator.clearAudioInfoAction());
            dispatch(FJActionAIAudioGenerator.clearVocalAudioInfoAction());
            dispatch(FJActionAIAudioGenerator.clearIncidentalAudioInfoAction());
        };
    },
    setIsMultipleModeAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsMultipleMode(bool));
        };
    },
    setHistoryTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceHistoryTabIndex(index));
        };
    },
    setLyricDescAction: function (value) {
        return dispatch => {
            dispatch(setSliceLyricDesc(value));
        };
    },
    changePromptAction: function (value) {
        return dispatch => {
            dispatch(setSlicePrompt(FJUtil.sliceByteLen(value, 200)));
        };
    },

    changeTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceTabIndex(index));
        };
    },

    setLyricContentAction: function (value) {
        return dispatch => {
            dispatch(setSliceLyricContent(FJUtil.sliceByteLen(value, 350)));
        };
    },

    setIncidentalAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceIncidentalAudioInfo({ ...info }));
        };
    },

    setAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceAudioInfo({ ...info }));
        };
    },

    setUploadAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceUploadAudioStatus(status));
        };
    },

    setVocalAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceVocalAudioInfo({ ...info }));
        };
    },

    setVocalAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceVocalUploadAudioStatus(status));
        };
    },

    setIncidentalAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceIncidentalAudioStatus(status));
        };
    },

    initAIAudioGeneratorAction: function () {
        return dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const { info, job_type, lyrics, prompt } = recIdInfo;
                if (job_type === 17) {
                    const useInfo = info;
                    if (lyrics) {
                        dispatch(this.setLyricContentAction(lyrics));
                        dispatch(this.changeTabIndexAction(0));
                        if (useInfo.songId) {
                            dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setAudioInfoAction({
                                    url:
                                        useInfo.songSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + useInfo.songId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.songId,
                                    name: useInfo.songName,
                                    source: useInfo.songSource,
                                }),
                            );
                        }
                        if (useInfo.voiceId) {
                            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setVocalAudioInfoAction({
                                    url:
                                        useInfo.voiceSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + useInfo.voiceId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.voiceId,
                                    name: useInfo.voiceName,
                                    source: useInfo.voiceSource,
                                }),
                            );
                        }
                    } else {
                        dispatch(this.changeTabIndexAction(1));
                        if (useInfo.instrumentalId) {
                            dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setIncidentalAudioInfoAction({
                                    url:
                                        useInfo.instrumentalSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST +
                                              FJConfig.originalSongKey +
                                              useInfo.instrumentalId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.instrumentalId,
                                    name: useInfo.instrumentalName,
                                    source: useInfo.instrumentalSource,
                                }),
                            );
                        }
                    }
                } else if (job_type === 21) {
                    dispatch(this.changeTabIndexAction(2));
                    dispatch(this.changePromptAction(prompt));
                } else {
                    dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        this.setAudioInfoAction({
                            url: recIdInfo.url,
                            name: recIdInfo.name,
                            source: recIdInfo.source,
                        }),
                    );
                }
            }

            const tabType = FJUtil.getQueryString('tab_type');
            if (tabType) {
                const tabIndex = tabType === 'sfx' ? 2 : 0;
                dispatch(this.changeTabIndexAction(tabIndex));
            }

            dispatch(this._initPresetAIAudioAction());
            // dispatch(this.updateHistoryListAction());
        };
    },

    _initPresetAIAudioAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.presetListJsonPath);
            const { list: presetList, sfxList, insList: insPreviewList } = await response.json();
            const usePresetList = presetList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.mp3', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    useStyle: item.style.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                    presetType: FJConstant.AUDIO_TAG_TYPE_MUSIC,
                };
            });

            const useSfxList = sfxList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.wav', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    presetType: FJConstant.AUDIO_TAG_TYPE_SFX,
                    usePrompt: item.prompt.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                };
            });

            const useInsList = insPreviewList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.mp3', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    presetType: FJConstant.AUDIO_TAG_TYPE_INST,
                    useStyle: item.style.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                };
            });

            const _shuffleArray = array => {
                for (let i = array.length - 1; i > 0; i--) {
                    // Generate a random index j such that 0 <= j <= i
                    const j = Math.floor(Math.random() * (i + 1));
                    // Swap elements at indexes i and j
                    [array[i], array[j]] = [array[j], array[i]];
                }
                return array;
            };

            dispatch(setSlicePresetList(_shuffleArray(usePresetList)));
            dispatch(setSliceSFXPresetList(_shuffleArray(useSfxList)));
            dispatch(setSliceInsPresetList(_shuffleArray(useInsList)));

            const referenceResponse = await fetch(FJConfig.referencePresetListJsonPath);
            const { referenceMusicList, referenceVocalList, instrumentalList } = await referenceResponse.json();

            const musicList = referenceMusicList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            const vocalList = referenceVocalList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            const insList = instrumentalList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            dispatch(setSliceReferenceMusicList(musicList));
            dispatch(setSliceReferenceVocalList(vocalList));
            dispatch(setSliceInstrumentalList(insList));
        };
    },

    onUseSampleInAudioFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();
            const referenceMusicList = state.AIAudioGenerator.referenceMusicList;
            const audioInfo = state.AIAudioGenerator.audioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * referenceMusicList.length);

                if (referenceMusicList[randomIndex].name === audioInfo.name) {
                    return __getRandom();
                }
                return referenceMusicList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUseSampleInVoiceFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();

            const referenceVocalList = state.AIAudioGenerator.referenceVocalList;
            const vocalAudioInfo = state.AIAudioGenerator.vocalAudioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * referenceVocalList.length);

                if (referenceVocalList[randomIndex].name === vocalAudioInfo.name) {
                    return __getRandom();
                }
                return referenceVocalList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setVocalAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUseSampleInIncidentalFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();
            const instrumentalList = state.AIAudioGenerator.instrumentalList;
            const incidentalAudioInfo = state.AIAudioGenerator.incidentalAudioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * instrumentalList.length);

                if (instrumentalList[randomIndex].name === incidentalAudioInfo.name) {
                    return __getRandom();
                }
                return instrumentalList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setIncidentalAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUsePresetInfoAction: function (info) {
        return dispatch => {
            FJAudioPlayManager.pauseAll();
            const { presetType } = info;
            switch (presetType) {
                case FJConstant.AUDIO_TAG_TYPE_MUSIC:
                    dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        this.setAudioInfoAction({
                            url: info.audioUrl,
                            duration: info.time,
                            name: info.name,
                            source: FJConstant.AI_AUDIO_FLEXCLIP,
                        }),
                    );
                    break;
                case FJConstant.AUDIO_TAG_TYPE_INST:
                    dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        this.setIncidentalAudioInfoAction({
                            url: info.audioUrl,
                            duration: info.time,
                            name: info.name,
                            source: FJConstant.AI_AUDIO_FLEXCLIP,
                        }),
                    );
                    break;
                case FJConstant.AUDIO_TAG_TYPE_SFX:
                    dispatch(this.changePromptAction(info.prompt));
                    break;
                default:
            }
        };
    },

    updateHistoryListAction: function (options = {}) {
        return async (dispatch, getState) => {
            const { ignoreLoading = false, callback = () => {} } = options;

            !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.LOADING));
            try {
                const list = await FJNetworkStore.getTaskList(FJConfig.historyListType.join(','));
                // const list = [
                //     {
                //         id: 14296,
                //         user_id: 362,
                //         event_id: 'ebcddb033837da8fe85fcfe5ac378713',
                //         original: '',
                //         result: 'ca44ea216763e7750558a32db05b5145.mp3',
                //         job_type: 17,
                //         has_watermark: 0,
                //         created_at: '2025-01-20 02:01:33',
                //         info: '{"songName":"Wake up to the Sunlight","songSource":2,"voiceName":"Classic (Female).mp3","voiceSource":2,"songId":"Female-Woke up to the sunlight.mp3","voiceId":"Classic Vocal (Female).mp3","instrumentalId":"","musicName":"Whispers Under Starry Skies","coverName":"09ecef4ac523b3c90dbcc4af192997b1.webp","audioWaveImgUrl":"567ada0dd607d1548f87cb845cc98792308f3ee68e2f3d9ce3d80e7e983b549c.png","audioWavePlayImgUrl":"0c816bd80f08c14f94ed9acd1250e47aedb8c340c88bd0b15c433730339a49a8.png"}',
                //         style: null,
                //         share_key: '14296dc5631bb775757e5ae1e430034ad1a21',
                //         request_params: {
                //             lyrics: 'In the quiet of the night,  \r\n\r\nwhispers dance like fireflies,  \r\n\r\ndreams take flight,  \r\n\r\nunderneath the starry skies.  \r\n\r\n  \r\n\r\nHeartbeats echo softly,  \r\n\r\nmemories drift like the breeze,  \r\n\r\nlost in time’s embrace,  \r\n\r\nfinding moments that tease.  \r\n\r\n  \r\n\r\nHold me close, never let go,  \r\n\r\nin this world where love can grow.  \r\n\r\nTogether we’ll chase the dawn,  \r\n\r\nwoven by a thread so strong.  ',
                //             state: 'completed',
                //         },
                //     },
                // ];
                if (list && list.length) {
                    const historyList = list.map(item => {
                        const info = JSON.parse(item.info);
                        const audioName = info.musicName;
                        return {
                            status: item?.request_params?.state,
                            lyrics: item?.request_params?.lyrics,
                            info: JSON.parse(item.info),
                            id: item.id,
                            createTime: item.created_at,
                            shareKey: item.share_key,
                            eventId: item.event_id,
                            audioName,
                            audioUrl: FJS3Config.S3_SERVER_HOST + FJConfig.resultSongKey + item.result,
                            coverName: info.coverName,
                            coverUrl: info.coverName
                                ? FJS3Config.S3_SERVER_HOST + FJConfig.resultSongKey + 'cover/' + info.coverName
                                : FJConfig.coverPath,
                            audioWaveImgUrl:
                                (info.audioWaveImgUrl
                                    ? FJS3Config.S3_SERVER_HOST + FJConfig.waveformKey + info.audioWaveImgUrl
                                    : null) || null,
                            audioWavePlayImgUrl:
                                (info.audioWavePlayImgUrl
                                    ? FJS3Config.S3_SERVER_HOST + FJConfig.waveformKey + info.audioWavePlayImgUrl
                                    : null) || null,
                            audioTagType:
                                item.job_type === 21
                                    ? FJConstant.AUDIO_TAG_TYPE_SFX
                                    : info.instrumentalId
                                      ? FJConstant.AUDIO_TAG_TYPE_INST
                                      : FJConstant.AUDIO_TAG_TYPE_MUSIC,
                            prompt: item?.request_params?.input_prompt || item?.request_params?.prompt,
                        };
                    });
                    const oldHistoryList = getState().common.historyList;
                    if (JSON.stringify(oldHistoryList) !== JSON.stringify(historyList)) {
                        dispatch(setSliceHistoryListAction(historyList));
                    }
                    dispatch(this.dealAudioWaveAction());
                    callback(historyList);
                } else {
                    dispatch(setSliceHistoryListAction([]));
                    callback([]);
                }
                dispatch(this.checkedUpdateTaskStatusAction());
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.SUCCESS));
            } catch (error) {
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.ERROR));
            }
        };
    },

    dealAudioWaveAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const historyList = state.common.historyList;
            const needWaveList = historyList.filter(
                item => item.status === 'completed' && (!item.audioWaveImgUrl || !item.audioWavePlayImgUrl),
            );
            if (needWaveList.length === 0) {
                return;
            }
            const curItem = needWaveList[0];
            if (f_currentWaveId === curItem.eventId) {
                return;
            }
            f_currentWaveId = curItem.eventId;
            const imgUrl = await FJUtil.getAudioWave(curItem.audioUrl);
            const hoverImgUrl = await FJUtil.getAudioWave(curItem.audioUrl, true);

            try {
                const file = await FJUtil.getBlobByUrl(imgUrl);
                const id = await FJUtil.hashEncode(file);
                const key = FJConfig.waveformKey + id + '.png';
                const result = await FJImageStore.upLoadFileToS3Async(file, key);

                const hoverFile = await FJUtil.getBlobByUrl(hoverImgUrl);
                const hoverId = await FJUtil.hashEncode(hoverFile);
                const hoverKey = FJConfig.waveformKey + hoverId + '.png';
                const hoverResult = await FJImageStore.upLoadFileToS3Async(hoverFile, hoverKey);

                if (result && hoverResult) {
                    await FJNetworkStore.updateEventInfo({
                        eventId: curItem.eventId,
                        info: {
                            audioWaveImgUrl: id + '.png',
                            audioWavePlayImgUrl: hoverId + '.png',
                        },
                    });
                    const nowHistoryList = getState().common.historyList;
                    const temp = [];
                    nowHistoryList.forEach(item => {
                        if (item.eventId === curItem.eventId) {
                            temp.push({
                                ...item,
                                audioWaveImgUrl: FJS3Config.S3_SERVER_HOST + key,
                                audioWavePlayImgUrl: FJS3Config.S3_SERVER_HOST + hoverKey,
                            });
                        } else {
                            temp.push({
                                ...item,
                            });
                        }
                    });
                    f_currentWaveId = null;
                    dispatch(setSliceHistoryListAction(temp));
                    dispatch(this.dealAudioWaveAction());
                } else {
                    f_currentWaveId = null;
                    dispatch(this.dealAudioWaveAction());
                }
            } catch (e) {
                console.log(e);
                f_currentWaveId = null;
            }
        };
    },

    /**
     * @description 上传音频
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );
            if (!isAudio) {
                _formatError();
                return;
            }
            dispatch(this.setUploadAudioStatusAction(FJConstant.LOADING));
            const audioUrl = URL.createObjectURL(file);
            const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
            if (audioDuration < 15) {
                _time15Error();
                dispatch(this.setUploadAudioStatusAction(uploadStatus));
                return;
            } else if (audioDuration > 10 * 60) {
                dispatch(this.setUploadAudioStatusAction(uploadStatus));
                _time600Error();
                return;
            }
            dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setAudioInfoAction({
                    url: audioUrl,
                    duration: FJUtil.formatTime(audioDuration, false, 2),
                    name: file.name,
                    type: 'local',
                }),
            );
        };
    },

    clearAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setUploadAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setAudioInfoAction({}));
        };
    },

    /**
     * @description 上传人声
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadVocalAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadVocalAudioStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );
            if (!isAudio) {
                _formatError();
                return;
            }
            dispatch(this.setVocalAudioStatusAction(FJConstant.LOADING));
            const audioUrl = URL.createObjectURL(file);
            const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
            if (audioDuration < 15) {
                _time15Error();
                dispatch(this.setVocalAudioStatusAction(uploadStatus));
                return;
            } else if (audioDuration > 10 * 60) {
                dispatch(this.setVocalAudioStatusAction(uploadStatus));
                _time600Error();
                return;
            }
            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setVocalAudioInfoAction({
                    url: audioUrl,
                    duration: FJUtil.formatTime(audioDuration, false, 2),
                    name: file.name,
                    type: 'local',
                }),
            );
        };
    },

    clearVocalAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setVocalAudioInfoAction({}));
        };
    },

    /**
     * @description 上传伴奏
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadIncidentalAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadIncidentalAudioStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );
            if (!isAudio) {
                _formatError();
                return;
            }
            dispatch(this.setIncidentalAudioStatusAction(FJConstant.LOADING));
            const audioUrl = URL.createObjectURL(file);
            const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
            if (audioDuration < 15) {
                _time15Error();
                dispatch(this.setIncidentalAudioStatusAction(uploadStatus));
                return;
            } else if (audioDuration > 10 * 60) {
                dispatch(this.setIncidentalAudioStatusAction(uploadStatus));
                _time600Error();
                return;
            }
            dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setIncidentalAudioInfoAction({
                    url: audioUrl,
                    duration: FJUtil.formatTime(audioDuration, false, 2),
                    name: file.name,
                    type: 'local',
                }),
            );
        };
    },

    clearIncidentalAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setIncidentalAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setIncidentalAudioInfoAction({}));
        };
    },

    onLyricContentChangeAction: function (value) {
        return dispatch => {
            dispatch(this.setLyricContentAction(value));
        };
    },

    onLyricDescChangeAction: function (value) {
        return dispatch => {
            dispatch(this.setLyricDescAction(value));
        };
    },

    /**
     * @description 通过AI生成歌词
     * @returns {(function(*, *): Promise<void>)|*}
     */
    generateLyricAction: function () {
        return async (dispatch, getState) => {
            if (!FJUtil.isLogin()) {
                FJUtil.login();
                return;
            }

            const state = getState();
            const lyricDesc = state.AIAudioGenerator.lyricDesc;
            FJUtil.eaLog('ai lyric generate click', { prompt: lyricDesc });
            const _prompt = lyricDesc.replace(/\s/g, '');
            if (_prompt.length === 0 || lyricDesc.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-lyrics-description'), 'error');
                return;
            }
            try {
                dispatch(setSliceIsGenerateLyricsLoading(true));
                const result = await FJNetworkStore.generateLyric({ content: lyricDesc });
                dispatch(this.setLyricContentAction(result.data.result));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('lyrics-generation-failed'), 'error');
            } finally {
                dispatch(setSliceIsGenerateLyricsLoading(false));
            }
        };
    },

    generateErrorAction: function () {
        return () => {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
        };
    },

    onGenerateAction: function () {
        return async (dispatch, getState) => {
            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(false));
            dispatch(setSliceSelectListAction([]));

            const state = getState();
            const creditNumber = state.common.creditNumber;

            const musicFreeNum = state.AIAudioGenerator.musicFreeNum;
            const intFreeNum = state.AIAudioGenerator.intFreeNum;
            const sfxFreeNum = state.AIAudioGenerator.sfxFreeNum;

            const { incidentalAudioInfo, audioInfo, vocalAudioInfo, lyricContent, tabIndex, prompt } =
                state.AIAudioGenerator;

            const freeNumCreation = tabIndex === 0 ? musicFreeNum : tabIndex === 1 ? intFreeNum : sfxFreeNum;

            const _lyricContent = lyricContent.replace(/\s/g, '');

            if (tabIndex === 0) {
                if (!audioInfo.url) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-reference-music-first'), 'error');
                    return;
                }
                if (_lyricContent.length === 0 || lyricContent.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-lyrics-first'), 'error');
                    return;
                }
            } else if (tabIndex === 1) {
                if (!incidentalAudioInfo.url) {
                    FJMessageStore.addMessage(FJLocalStore._('please-upload-reference-music-first'), 'error');
                    return;
                }
            } else if (tabIndex === 2) {
                const _prompt = prompt.replace(/\s/g, '');
                if (_prompt.length === 0 || prompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    return;
                }
            }

            dispatch(setSliceTaskStatusAction(FJConstant.START));

            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            if (AI_AUDIO_USE_CREDIT > creditNumber && freeNumCreation === 0) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            const _dealFile = async info => {
                const file = await FJUtil.getBlobByUrl(info.url);
                const id = await FJUtil.hashEncode(file);

                const key = FJConfig.originalSongKey + id + '.' + FJUtil.getFileSuffix(info.name);
                const result = await FJImageStore.upLoadFileToS3Async(file, key);
                if (result) {
                    return FJS3Config.S3_SERVER_HOST + key;
                } else {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                }
            };

            let audioUrl = audioInfo.url;
            let voiceUrl = vocalAudioInfo.url;
            let incidentalUrl = incidentalAudioInfo.url;
            let lyrics = lyricContent;
            let info = {};
            if (tabIndex === 0) {
                incidentalUrl = null;
                // 上传s3
                if (audioInfo.type === 'local') {
                    audioUrl = await _dealFile(audioInfo);
                    if (!audioUrl) {
                        return;
                    }
                }
                info.songName = audioInfo.name;
                info.songSource = audioInfo.source || FJConstant.AI_AUDIO_S3;

                if (vocalAudioInfo.type === 'local') {
                    voiceUrl = await _dealFile(vocalAudioInfo);
                    if (!voiceUrl) {
                        return;
                    }
                }
                if (vocalAudioInfo.name) {
                    info.voiceName = vocalAudioInfo.name;
                    info.voiceSource = vocalAudioInfo.source || FJConstant.AI_AUDIO_S3;
                }
            } else if (tabIndex === 1) {
                audioUrl = null;
                voiceUrl = null;
                lyrics = null;
                if (incidentalAudioInfo.type === 'local') {
                    incidentalUrl = await _dealFile(incidentalAudioInfo);
                    if (!incidentalUrl) {
                        return;
                    }
                }
                info.instrumentalName = incidentalAudioInfo.name;
                info.instrumentalSource = incidentalAudioInfo.source || FJConstant.AI_AUDIO_S3;
            }

            FJUtil.eaLog('ai music generate click', {
                mode: tabIndex === 0 ? 'vocal' : tabIndex === 1 ? 'instrumental' : 'sfx',
                prompt: tabIndex === 2 ? prompt : '',
            });
            FJUtil.eaLog(' ai tool start generating', {
                tool: FJUtil.getToolName(),
            });

            // AI生成音乐
            const _request = async () => {
                if (tabIndex === 0 || tabIndex === 1) {
                    return await FJNetworkStore.audioGeneration({
                        audioUrl,
                        voiceUrl,
                        incidentalUrl,
                        lyrics,
                        info,
                    });
                } else if (tabIndex === 2) {
                    const isEnglish = FJUtil.isEnglish(prompt);
                    return await FJNetworkStore.soundEffectGeneration({
                        prompt,
                        isEnglish,
                    });
                }
            };

            await FJActionCommon.createRequestTask(_request, dispatch);
            FJUtil.updateAllCreditInfo();

            dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            dispatch(this.updateHistoryListAction({ ignoreLoading: true }));

            dispatch(this.setHistoryTabIndexAction(tabIndex + 1));
        };
    },

    checkedUpdateTaskStatusAction: function () {
        return dispatch => {
            if (f_timer) {
                return;
            }
            dispatch(this.pollingAudioGeneratorTaskListAction());
        };
    },

    pollingAudioGeneratorTaskListAction: function () {
        return async (dispatch, getState) => {
            const _clear = () => {
                if (f_timer) {
                    clearTimeout(f_timer);
                    f_timer = null;
                }
            };

            const state = getState();
            const historyList = state.common.historyList;
            const generatingTaskIdList = historyList
                .filter(item => item.status === 'progress')
                .map(item => item.eventId);

            if (generatingTaskIdList.length === 0) {
                _clear();
                return;
            }

            const delayTime = TASK_POLLING_INTERVAL * 5;
            const __pollingFunc = () => {
                dispatch(this.pollingAudioGeneratorTaskListAction());
            };

            try {
                const result = await FJNetworkStore.getTaskState(generatingTaskIdList.join(','));
                let isStopPolling = false;
                let data = result;

                if (!data) {
                    f_errorTime++;
                    if (f_errorTime >= MAX_POLLING_ERROR_TIME) {
                        _clear();
                    } else {
                        _clear();
                        f_timer = setTimeout(__pollingFunc, delayTime);
                    }
                    return;
                }

                if (!Array.isArray(result)) {
                    // 处理数组类型的data
                    data = [result];
                }

                let failTaskCount = 0;
                let isNeedUpdate = false;
                await Promise.all(
                    data.map(async item => {
                        switch (item.job_state) {
                            case 'succeeded':
                                isNeedUpdate = true;
                                try {
                                    if (item.out_put) {
                                        const tempInfo = JSON.parse(item.out_put[0].info);
                                        FJUtil.eaLog('ai music generate success', {
                                            mode:
                                                item.job_type === 21
                                                    ? 'sfx'
                                                    : tempInfo.songId
                                                      ? 'vocal'
                                                      : 'instrumental',
                                        });

                                        FJUtil.eaLog('ai tool generate success', {
                                            tool: FJUtil.getToolName(),
                                        });
                                    }
                                } catch (e) {
                                    console.log(e);
                                }

                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                break;
                            case 'failed': {
                                isNeedUpdate = true;
                                failTaskCount++;
                                //todo: 失败更新免费次数
                                FJUtil.updateAllCreditInfo(true);

                                if (failTaskCount === generatingTaskIdList.length) {
                                    isStopPolling = true;
                                }
                                let ealogReason = 'failed';
                                try {
                                    if (item.out_put) {
                                        const tempInfo = JSON.parse(item.out_put[0].info);
                                        if (
                                            tempInfo.error.indexOf('Error generating music: Music upload failed: 1000')
                                        ) {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('the-uploaded-music-has-no-sound'),
                                                'error',
                                            );
                                            ealogReason = 'no sound';
                                        } else {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('music-generation-failed'),
                                                'error',
                                            );
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                                FJUtil.eaLog('ai music generate failed', { reason: ealogReason });
                                break;
                            }
                            default:
                                break;
                        }
                    }),
                );
                if (isStopPolling) {
                    _clear();
                } else {
                    _clear();
                    f_timer = setTimeout(__pollingFunc, delayTime);
                }
                if (isNeedUpdate) {
                    dispatch(this.updateHistoryListAction({ ignoreLoading: true }));
                }
            } catch (error) {
                console.log(error);
                _clear();
            }
        };
    },

    retryAIAudioAction: function (item) {
        return dispatch => {
            const info = item.info;
            if (info.prompt) {
                dispatch(this.changeTabIndexAction(2));
                dispatch(this.changePromptAction(info.prompt));
            } else if (info.instrumentalId) {
                // 伴奏生成
                dispatch(this.changeTabIndexAction(1));
                dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                dispatch(
                    this.setIncidentalAudioInfoAction({
                        url:
                            info.instrumentalSource === FJConstant.AI_AUDIO_S3
                                ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.instrumentalId
                                : window.location.origin + FJConfig.presetPreviewPath + 'audio/' + info.instrumentalId,
                        name: info.instrumentalName,
                        source: info.instrumentalSource,
                    }),
                );
            } else {
                dispatch(this.changeTabIndexAction(0));
                dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                dispatch(
                    this.setAudioInfoAction({
                        url:
                            info.songSource === FJConstant.AI_AUDIO_S3
                                ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.songId
                                : window.location.origin + FJConfig.presetPreviewPath + 'audio/' + info.songId,
                        name: info.songName,
                        source: info.songSource,
                    }),
                );
                if (info.voiceId) {
                    dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        this.setVocalAudioInfoAction({
                            url:
                                info.voiceSource === FJConstant.AI_AUDIO_S3
                                    ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.voiceId
                                    : window.location.origin + FJConfig.presetPreviewPath + 'audio/' + info.voiceId,
                            name: info.voiceName,
                            source: info.voiceSource,
                        }),
                    );
                } else {
                    dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
                    dispatch(this.setVocalAudioInfoAction({}));
                }

                const textArea = document.createElement('textarea');
                textArea.value = item.lyrics;
                dispatch(this.setLyricContentAction(textArea.value));
            }
        };
    },

    applyRecordAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const audioName = state.record.audioName;
            const audioUrl = state.record.audioUrl;
            const mimeType = 'audio/mpeg';
            const audioBlob = await FJUtil.getBlobByUrl(audioUrl);
            const audioFile = new File([audioBlob], audioName, { type: mimeType });
            Download(audioFile, audioName, mimeType);
            dispatch(FJActionModal.hideRecordModalAction());
            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setVocalAudioInfoAction({
                    url: audioUrl,
                    name: audioName,
                    type: 'local',
                }),
            );
            dispatch(FJActionRecord.setRecordStatusAction(FJConstant.DEFAULT));
            dispatch(FJActionRecord.setAudioUrlAction(''));
            dispatch(FJActionRecord.setAudioNameAction(''));
        };
    },

    addToMediaLibraryAction: function (ids) {
        return (dispatch, getState) => {
            const { historyList } = getState().common;
            const urls = historyList
                .filter(item => ids.includes(item.id) && item.status === 'completed')
                .map(item => item.audioUrl);

            if (urls.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('unable-to-perform-this-operation-video'), 'error');
                return;
            }

            if (urls.length === 1) {
                dispatch(FJActionEditPage.addToMediaLibraryAction(urls[0], { from: 'generate' }));
            } else {
                dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(urls, { from: 'generate' }));
            }
        };
    },

    /**
     * @description 获取灵感
     * @returns
     */
    getInspireAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const curPrompt = state.AIAudioGenerator.prompt;

            const inspireListByLang = [
                'Heavy rain mixed with thunder',
                'Many horses are running wildly on the grassland',
                'Typing on mechanical keyboard',
                'Supercar acceleration sprint',
                'Wind through pine trees',
                'Ocean waves crashing',
                'Seagull cry fading into distance',
                'Birds are singing in the rainforest',
                'The joyful sounds of children playing',
            ];

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireListByLang.length);

                if (inspireListByLang[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireListByLang[randomIndex];
            };

            const prompt = __getRandomInspire();

            dispatch(this.changePromptAction(prompt));
        };
    },

    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            dispatch(setSliceMusicFreeNumCreationAction(info['music-generator']));
            dispatch(setSliceIntFreeNumCreationAction(info['audio-accompany-generator']));
            dispatch(setSliceSFXFreeNumCreationAction(info['audio-effect-generator']));
        };
    },
};

export default FJActionAIAudioGenerator;
